<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <modal-link modal-id="How to Use" :content-list="pageContent" :image-size="'large'"></modal-link>
      {{ chart.title }}
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria ref="chartCriteria" display-type-label="Profile Types" showUseTTMAsStartDate="true" :show-match-type="true" :use-chart-type-card="true" :show-display-type="true" :is-comparative="true" time-period-label="Period" :content-list="pageContent" @reset-client-chart="resetClientChart">
      </chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  v-bind:criteria-results-list="criteriaResultsList"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"
                ></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <MatchByNeed v-show="isMatchByNeed && !generatingChart" :chart-data="chartData" :content-list="pageContent"></MatchByNeed>
              <MatchByValue v-show="isMatchByValue && !generatingChart" :chart-data="chartData" :content-list="pageContent"></MatchByValue>
              <MatchByWinners v-show="isMatchByWinners && !generatingChart" :chart-data="chartData" :content-list="pageContent"></MatchByWinners>
              <MatchByMoat v-show="isMatchByMoat && !generatingChart" :chart-data="chartData" :content-list="pageContent"></MatchByMoat>
              <ByWordCloud v-show="isMatchByWordCloud && !generatingChart" :chart-data="chartData" :include-word-cloud="false"></ByWordCloud>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContent" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
    </vue-modal>
    <vue-modal ref="print-chart" name="print-chart" :width="350" :height="200">
      <chart-criteria-results
        ref="chartCriteriaResults"
        v-bind:criteria-results-list="criteriaResultsList"
        v-bind:criteria-results-company-list="criteriaResultsCompanyList"
      ></chart-criteria-results>
    </vue-modal>
    <road-map-initiatives ref="roadMapInitiativesForProfileTable" :modal-name="'road-map-initiatives-profile'" :display-initiatives="false" />      
    <explore-navigation-modal  ref="exploreNavigationModal" :modal-name="'explore-navigation-modal'" :modal-id="'explore-navigation-modal'"/>  
  </div>
</template>
<script>
import RoadMapInitiatives from "../../modals/RoadMapInitiatives.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";

import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import MatchByNeed from "./type/MatchByNeed.vue";
import MatchByValue from "./type/MatchByValue.vue";
import MatchByMoat from "./type/MatchByMoat.vue";
import MatchByWinners from "./type/MatchByWinners.vue";
import ByWordCloud  from "./type/ByWordCloud.vue";

import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import ContentService from "../../services/content.service";

export default {
  name: "ProfileMatch",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    MatchByNeed,
    MatchByValue,
    MatchByWinners,
    MatchByMoat,
    ByWordCloud,
    ChartDisplaySkeleton,
    ExploreNavigationModal,
    RoadMapInitiatives
  },
  data() {
    return {
      title: "Match",
      pageNumber: 8,
      isMatchByNeed: true,
      isMatchByValue: false,
      isMatchByMoat: false,
      isMatchByWinners: false,
      isMatchByWordCloud: false,
      chartData: [],
      
    };
  },
  methods: {
    displayChartCallback(response) {
      try {
        this.$root.processServerResponse();
        this.generatingChart = false;

        this.chartData = response.data;
        this.isMatchByNeed = this.$refs.chartCriteria.$data.displayType == "need";
        this.isMatchByValue = this.$refs.chartCriteria.$data.displayType == "value";
        this.isMatchByMoat = this.$refs.chartCriteria.$data.displayType == "moat";
        this.isMatchByWinners = this.$refs.chartCriteria.$data.displayType == "winners";
        this.isMatchByWordCloud  = this.$refs.chartCriteria.$data.displayType == "nps";
      } catch (err) {
        ErrorService.processException("ProfileMatch.displayChartCallback", err, "chart", this);
      }
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    displayInitiativesForProfileTable(element) {
      let needName = element.name;
      let moatName = element.moatName;
      let moatDescription = element.moatDescription;
      if (moatDescription == null) {
        moatDescription = {
          description: "",
          attributes: "{}"
        };
      }
      let initiativeSuggestions = element.initiativeSuggestions;
      this.$refs.roadMapInitiativesForProfileTable.$data.title = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.moatName = moatName;
      this.$refs.roadMapInitiativesForProfileTable.$data.needName = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.initiatives = JSON.parse(JSON.stringify(initiativeSuggestions));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatDescription = JSON.parse(JSON.stringify(moatDescription));
      this.$refs.roadMapInitiativesForProfileTable.loadData();
      this.$modal.show("road-map-initiatives-profile");
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
  },
  umnounted() {},
  computed: {},
  props: {},
  mounted() {},
  created() {
    this.chart = ChartService.getChartAttributes("Match");
  },
  watch: {}
};
</script>
